import {
  Box,
  Button,
  Center,
  Heading,
  HStack,
  Spinner,
  Stack,
  Text,
} from '@chakra-ui/react'
import UsersTable from '../../../components/UsersTable'
import { useReportGeneration } from './hooks/useReportGeneration'
import ReportFilters from './components/ReportFilters'
import { DATE_REQUIRED_REPORTS } from './utils/reportConstants'

export default function Reports() {
  const {
    reportType,
    setReportType,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    hasGenerated,
    setHasGenerated,
    loading,
    docs,
    generateReport,
  } = useReportGeneration()

  return (
    <Stack spacing={4}>
      <Heading as='h2' size='lg'>
        Generate Report
      </Heading>

      <ReportFilters
        reportType={reportType}
        startDate={startDate}
        endDate={endDate}
        onReportTypeChange={(type) => {
          setReportType(type)
          setHasGenerated(false)
        }}
        onStartDateChange={(date) => {
          setStartDate(date)
          setHasGenerated(false)
        }}
        onEndDateChange={(date) => {
          setEndDate(date)
          setHasGenerated(false)
        }}
      />

      <Button
        colorScheme='blue'
        onClick={generateReport}
        isLoading={loading}
        isDisabled={
          !reportType ||
          (DATE_REQUIRED_REPORTS.has(reportType) && (!startDate || !endDate))
        }
      >
        Generate Report
      </Button>

      {loading && (
        <Center py={10}>
          <Spinner size='xl' color='blue.500' thickness='4px' />
        </Center>
      )}

      {!loading && docs.length > 0 && (
        <>
          <HStack spacing={2}>
            <Text fontWeight='bold'>Total Found: {docs.length}</Text>
          </HStack>
          <UsersTable docs={docs} isLoading={false} />
        </>
      )}

      {!loading &&
        hasGenerated &&
        docs.length === 0 &&
        reportType &&
        (!DATE_REQUIRED_REPORTS.has(reportType) ||
          (startDate && endDate)) && (
          <Box mt={5}>
            <Text>
              No users found for the selected criteria
              {DATE_REQUIRED_REPORTS.has(reportType) ? ' and date range' : ''}.
            </Text>
          </Box>
        )}
    </Stack>
  )
}
